module.exports = {"130671202":"贤台乡","130671205":"大马坊乡","130671400":"保定国家高新区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130671.json
// module id = 259
// module chunks = 0